import { render, staticRenderFns } from "./JsonSchemaForm.vue?vue&type=template&id=14b38640&scoped=true&"
import script from "./JsonSchemaForm.vue?vue&type=script&lang=js&"
export * from "./JsonSchemaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b38640",
  null
  
)

export default component.exports